export default __webpack_public_path__ + "static/media/bookmark.6326e38a.svg";